module.exports = __webpack_public_path__ + "img/9788996056188.abf9228a.jpg";